import React from 'react';
import { Icon } from './Icon.js';
export const IconParkingSignFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M9.5,6.5h-1.5v2h1.5c.551,0,1-.449,1-1s-.449-1-1-1Z", fill: "currentColor" }),
        React.createElement("path", { d: "M13.25,2H4.75c-1.517,0-2.75,1.233-2.75,2.75V13.25c0,1.517,1.233,2.75,2.75,2.75H13.25c1.517,0,2.75-1.233,2.75-2.75V4.75c0-1.517-1.233-2.75-2.75-2.75Zm-3.75,8h-1.5v2.25c0,.414-.336,.75-.75,.75s-.75-.336-.75-.75V5.75c0-.414,.336-.75,.75-.75h2.25c1.378,0,2.5,1.122,2.5,2.5s-1.122,2.5-2.5,2.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconParkingSignFill18.js.map